
import {configureStore} from '@reduxjs/toolkit'
import  useReducer  from '../reducer/user.reducer'
import customerReducer from '../reducer/customer.reducer'
import { CollectionApi } from '../api/collection.api'
import { ProductApi } from '../api/product.api'
import { customerApi } from '../api/customer.api'
import { orderApi } from '../api/order.api'
import { FeaturedProductApi } from '../api/featuredProduct.api'
import {BannersApi} from '../api/banners.api'
import { GalleryApi } from '../api/gallery.api'
import { CustomerGalleryApi } from '../api/customergallery.api'
import { PromoApi } from '../api/promo.api'
import { SalesApi } from '../api/sales.api'
import { PageApi } from '../api/page.api'
import { paymentApi } from '../api/payment.api'
import { ExpenseApi } from '../api/expense.api'
import { DashboardApi } from '../api/dashboard.api'
import { ExportApi } from '../api/export.api'
import cartReducer from '../reducer/cart.reducer'

const storeConfig = configureStore({
    reducer:{
        user: useReducer,
        customer: customerReducer,
        cart: cartReducer,
        [CollectionApi.reducerPath]: CollectionApi.reducer,
        [ProductApi.reducerPath]:ProductApi.reducer,
        [customerApi.reducerPath]:customerApi.reducer,
        [orderApi.reducerPath]:orderApi.reducer,
        [FeaturedProductApi.reducerPath]:FeaturedProductApi.reducer,
        [BannersApi.reducerPath]:BannersApi.reducer,
        [GalleryApi.reducerPath]:GalleryApi.reducer,
        [CustomerGalleryApi.reducerPath]:CustomerGalleryApi.reducer,
        [PromoApi.reducerPath]:PromoApi.reducer,
        [SalesApi.reducerPath]:SalesApi.reducer,
        [PageApi.reducerPath]:PageApi.reducer,
        [paymentApi.reducerPath]: paymentApi.reducer,
        [ExpenseApi.reducerPath]: ExpenseApi.reducer,
        [DashboardApi.reducerPath]: DashboardApi.reducer,
        [ExportApi.reducerPath]: ExportApi.reducer,
    },
    //bind middleware
    middleware:(getDefaultMiddleware)=>
        getDefaultMiddleware()
        .concat(CollectionApi.middleware)
        .concat(ProductApi.middleware)
        .concat(customerApi.middleware)
        .concat(orderApi.middleware)
        .concat(FeaturedProductApi.middleware)
        .concat(BannersApi.middleware)
        .concat(GalleryApi.middleware)
        .concat(CustomerGalleryApi.middleware)
        .concat(PromoApi.middleware)
        .concat(SalesApi.middleware)
        .concat(PageApi.middleware)
        .concat(paymentApi.middleware)
        .concat(ExpenseApi.middleware)
        .concat(DashboardApi.middleware)
        .concat(ExportApi.middleware)
})

export default storeConfig